import { render, staticRenderFns } from "./CellRaspred.vue?vue&type=template&id=2266b8e6"
import script from "./CellRaspred.vue?vue&type=script&lang=js"
export * from "./CellRaspred.vue?vue&type=script&lang=js"
import style0 from "./CellRaspred.vue?vue&type=style&index=0&id=2266b8e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports